import React, {useState, useCallback, ReactNode} from 'react';
import {Box} from '@mui/material';

type AurAnimatedCardProps = {
  children: ReactNode;
};

const AurAnimatedCard: React.FC<AurAnimatedCardProps> = ({children}) => {
  const [mousePos, setMousePos] = useState({x: 0, y: 0});

  const handleMouseMove = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      const rect = event.currentTarget.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      setMousePos({x, y});
    },
    []
  );

  const cardStyles = {
    bgcolor: '#121A25',
    color: '#ffffff',
    padding: '18px',
    borderRadius: 2,
    border: '1px solid #2D3D55',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    height: '237px',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      background: `radial-gradient(farthest-corner ellipse at ${mousePos.x}px ${mousePos.y}px,
        #3845AD66 0%,
        #3845AD00 50%)`,
      border: '1px solid #5265FF',
    },
  };

  return (
    <Box className="client-box" onMouseMove={handleMouseMove} sx={cardStyles}>
      {children}
    </Box>
  );
};

export default AurAnimatedCard;
